// src/hooks/useBlog.js
import { useState, useEffect, useCallback } from 'react';
import { BlogService } from '../api/blog.api';

export const useBlog = (slug) => {
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [relatedPosts, setRelatedPosts] = useState([]);

    useEffect(() => {
        const fetchBlog = async () => {
            if (!slug) return;

            setLoading(true);
            setError(null);

            try {
                const response = await BlogService.getBlogBySlug(slug);

                // ✅ FIX: Extract real blog data
                const blogData = response?.data?.data || response?.data;

                if (!blogData) {
                    throw new Error("Blog not found");
                }

                setBlog(blogData);

                // Fetch related posts
                const relatedResponse = await BlogService.getRelatedPosts(slug, 3);
                const relatedData = relatedResponse?.data?.data || relatedResponse?.data || [];
                setRelatedPosts(relatedData);

            } catch (err) {
                setError(err.message || "Failed to load blog");
            } finally {
                setLoading(false);
            }
        };

        fetchBlog();
    }, [slug]);

    return { blog, loading, error, relatedPosts };
};

export const useBlogList = (initialFilters = {}) => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalBlogs: 0,
        limit: 12
    });
    const [filters, setFilters] = useState(initialFilters);

    const fetchBlogs = useCallback(async () => {
        setLoading(true);
        setError(null);

        try {
            const data = await BlogService.getAllBlogs(filters);
            setBlogs(data.data || []);
            setPagination(data.pagination || {
                currentPage: filters.page || 1,
                totalPages: data.totalPages || 1,
                totalBlogs: data.total || 0,
                limit: filters.limit || 12
            });
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, [filters]);

    useEffect(() => {
        fetchBlogs();
    }, [fetchBlogs]);

    const updateFilters = (newFilters) => {
        setFilters(prev => ({ ...prev, ...newFilters }));
    };

    return {
        blogs,
        loading,
        error,
        pagination,
        filters,
        updateFilters,
        refetch: fetchBlogs
    };
};